/**
 * Zone.js flags — must execute before zone.js loads, so polyfills.ts imports this file
 * immediately before `import 'zone.js'` (a bare statement in polyfills.ts would not work:
 * webpack hoists imports above statements).
 *
 * UNPATCHED_EVENTS makes addEventListener for these event names bypass zone.js entirely,
 * so firing them never schedules an app-wide change-detection tick — from ANY listener,
 * including ones registered by third-party libraries that we cannot wrap in
 * runOutsideAngular (PCIS-11524):
 *
 * - 'mousemove'/'touchmove': fire dozens of times per second. @ng-idle's
 *   DocumentInterruptSource registers them via a zone-patched fromEvent(document, ...),
 *   and it re-attaches them on every idle/active cycle, so wrapping one attach site in
 *   runOutsideAngular is not enough. ng-idle itself does not need the patch: its watch
 *   timers already run outside the zone and it re-enters via zone.run() when emitting
 *   idle lifecycle events. A live profile on the Additional Reports page showed a full
 *   change-detection pass per mousemove consuming 98% of a 38s main-thread freeze.
 * - 'storage': fired in EVERY other open same-origin tab on each localStorage write
 *   (e.g. the per-user-interaction 'sessionTime' write). Both AppComponent's cross-tab
 *   listener and @ng-idle's StorageInterruptSource listen for it; zone-patched, each
 *   write in one tab forced a full change-detection pass in every other tab regardless
 *   of what the handler bodies did — the "report launched in new tab freezes the
 *   original tab" mechanism. AppComponent's storage listener re-enters the zone
 *   explicitly (ngZone.run) in the one branch that updates UI (language change).
 *
 * Do NOT add discrete user-action events here (click, keydown, input, scroll, ...):
 * components legitimately rely on those to trigger view updates.
 */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['mousemove', 'touchmove', 'storage'];
